import type { ReactNode } from 'react'

import { CardProvider } from './card-context'
import { useCard, type TUseCardProps } from './useCard'

export type TCardProps = TUseCardProps

export const Card = ({ ref, ...props }: TCardProps): ReactNode => {
  const { dataTestId, children, context, Component, getCardProps } = useCard(props)

  return (
    <CardProvider value={context}>
      <Component ref={ref} testID={dataTestId} {...getCardProps()}>
        {children}
      </Component>
    </CardProvider>
  )
}

Card.displayName = 'Card'
